"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetDriveCompatibilityRequirementInstanceResultMetadataSchema = void 0;
const zod_1 = require("zod");
exports.NetDriveCompatibilityRequirementInstanceResultMetadataSchema = zod_1.z.object({
    type: zod_1.z.literal('NetDriveCompatibilityResultMetadata'),
});
//# sourceMappingURL=NetDriveCompatibilityRequirementInstanceResultMetadataSchema.js.map